var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('embed',{staticClass:"pdfView",attrs:{"src":"/StackAssist%20Help.pdf","type":"application/pdf"}})}
var staticRenderFns = []

export { render, staticRenderFns }